import React from 'react';
import { motion } from 'framer-motion';
import { Flame, Clock } from 'lucide-react';
interface UrgencyBadgeProps {
  variant?: 'fire' | 'clock' | 'dot';
  label?: string;
  tone?: 'light' | 'dark';
  className?: string;
}
/**
 * Small attention-grabbing badge to sit next to CTA buttons.
 * Pulsing red dot + optional icon and short urgency label.
 * tone="light" -> for dark backgrounds (default)
 * tone="dark"  -> for light card backgrounds
 */
export function UrgencyBadge({
  variant = 'dot',
  label,
  tone = 'light',
  className
}: UrgencyBadgeProps) {
  const textClass = tone === 'light' ? 'text-honey-light' : 'text-forest-deep';
  const iconClass = tone === 'light' ? 'text-honey-light' : 'text-terracotta';
  return <div className={`inline-flex items-center gap-2 ${className || ''}`} data-id="element-446">
      <span className="relative inline-flex h-3 w-3" data-id="element-447">
        <motion.span animate={{
        scale: [1, 1.8, 1],
        opacity: [0.6, 0, 0.6]
      }} transition={{
        duration: 1.6,
        repeat: Infinity,
        ease: 'easeOut'
      }} className="absolute inline-flex h-full w-full rounded-full bg-red-500" data-id="element-448" />
        <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500 border border-red-300" data-id="element-449" />
      </span>
      {variant === 'fire' && <Flame className={`w-4 h-4 ${iconClass} fill-honey/40`} data-id="element-450" />}
      {variant === 'clock' && <Clock className={`w-4 h-4 ${iconClass}`} data-id="element-451" />}
      {label && <span className={`text-[11px] font-extrabold uppercase tracking-widest ${textClass}`} data-id="element-452">
          {label}
        </span>}
    </div>;
}